import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import BeachAccess from "@material-ui/icons/BeachAccess";
import Dashboard from "@material-ui/icons/Dashboard";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import Lock from "@material-ui/icons/Lock";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SupervisedUserCircle from "@material-ui/icons/SupervisorAccount";
import React from "react";
import { RoleEnum } from "../../interfaces";

export interface LinksMap {
  [key: string]: LinkItemMap[];
}

export interface LinkItemMap {
  text: string;
  path: string;
  icon?: any;
}

export default {
  [RoleEnum.ADMIN]: [
    { path: "/", icon: <Dashboard />, text: "Dashboard" },
    { path: "/city", icon: <LocationCityIcon />, text: "Città" },
    { path: "/beach", icon: <BeachAccess />, text: "Spiaggia" },
    { path: "/holder", icon: <SupervisedUserCircle />, text: "Gestore" },
    {
      path: "/officer",
      icon: <AssignmentIndIcon />,
      text: "Ente responsabile",
    },
    { path: "/privacy", icon: <VisibilityIcon />, text: "Privacy" },
  ],
  [RoleEnum.HOLDER]: [
    { path: "/", icon: <Dashboard />, text: "Dashboard" },
    { path: "/beach", icon: <BeachAccess />, text: "Spiaggia" },
    { path: "/privacy", icon: <VisibilityIcon />, text: "Privacy" },
  ],
  [RoleEnum.OFFICER]: [],
  [RoleEnum.USER]: [],
  default: [
    { path: "/", icon: <Lock />, text: "Login" },
    { path: "/privacy", icon: <VisibilityIcon />, text: "Privacy" },
  ],
} as LinksMap;
